import { type ElementType } from 'react';
import {
  HeaderCarouselButtons,
  HeaderIcon,
  HeaderLeftSide,
  HeaderRightSide,
  HeaderTitle,
} from '@/components/common/cards-section/header';

type GamesSectionHeaderProps = {
  title?: string;
  Icon?: ElementType;
  type?: string;
  gamesLength?: number;
};

const GamesSectionHeader = ({ title, Icon, type, gamesLength }: GamesSectionHeaderProps) => {
  return (
    <>
      <HeaderLeftSide className="rtl:space-x-reverse">
        {Icon && (
          <HeaderIcon>
            <Icon />
          </HeaderIcon>
        )}
        {title && <HeaderTitle>{title}</HeaderTitle>}
      </HeaderLeftSide>
      <HeaderRightSide>
        <HeaderCarouselButtons
          type={type}
          gamesLength={gamesLength}
        />
      </HeaderRightSide>
    </>
  );
};

export default GamesSectionHeader;
